(function () {
  var DESKTOP_MQ = window.matchMedia('(min-width: 780px)');
  var STICKY_GAP = 16;

  function measureHeaderHeight() {
    var header =
      document.querySelector('#shopify-header-section.header--pebble') ||
      document.querySelector('#shopify-header-section') ||
      document.querySelector('sticky-header');

    if (header) {
      return Math.ceil(header.getBoundingClientRect().height);
    }

    var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
    var height = parseFloat(raw);
    return Number.isFinite(height) ? height : 92;
  }

  function syncStickyTop() {
    var headerHeight = measureHeaderHeight();

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--pebble-product-sticky-top', headerHeight + STICKY_GAP + 'px');
  }

  function syncHeroLayout(hero) {
    if (!DESKTOP_MQ.matches) {
      hero.style.removeProperty('--pebble-gallery-height');
      hero.querySelector('.pebble-product__info-wrap')?.style.removeProperty('min-height');
      return;
    }

    var gallery = hero.querySelector('.pebble-product__gallery');
    var infoWrap = hero.querySelector('.pebble-product__info-wrap');

    if (!gallery || !infoWrap) return;

    var galleryHeight = gallery.offsetHeight;

    hero.style.setProperty('--pebble-gallery-height', galleryHeight + 'px');
    infoWrap.style.minHeight = galleryHeight + 'px';
  }

  function initHero(hero) {
    if (hero.dataset.pebbleScrollInit === 'true') return;
    hero.dataset.pebbleScrollInit = 'true';

    var gallery = hero.querySelector('.pebble-product__gallery');
    var infoWrap = hero.querySelector('.pebble-product__info-wrap');

    if (!gallery || !infoWrap) return;

    function refresh() {
      syncStickyTop();
      syncHeroLayout(hero);
    }

    refresh();

    requestAnimationFrame(function () {
      requestAnimationFrame(refresh);
    });

    gallery.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', refresh, { once: true });
      }
    });

    if (typeof ResizeObserver !== 'undefined') {
      var observer = new ResizeObserver(refresh);
      observer.observe(gallery);
      observer.observe(infoWrap);
    }

    window.addEventListener('resize', refresh, { passive: true });
    window.addEventListener('load', refresh);

    hero.querySelectorAll('.pebble-product-accordion details, product-recommendations details').forEach(function (details) {
      details.addEventListener('toggle', refresh);
    });
  }

  function boot(context) {
    syncStickyTop();
    (context || document).querySelectorAll('.main-product--pebble .pebble-product__hero').forEach(function (hero) {
      initHero(hero);
      syncHeroLayout(hero);
    });
  }

  function onMqChange() {
    boot();
  }

  if (typeof DESKTOP_MQ.addEventListener === 'function') {
    DESKTOP_MQ.addEventListener('change', onMqChange);
  } else if (typeof DESKTOP_MQ.addListener === 'function') {
    DESKTOP_MQ.addListener(onMqChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('scroll', syncStickyTop, { passive: true });
  window.addEventListener('resize', syncStickyTop, { passive: true });
  window.addEventListener('load', syncStickyTop);

  var header =
    document.querySelector('#shopify-header-section.header--pebble') ||
    document.querySelector('#shopify-header-section');

  if (header && typeof ResizeObserver !== 'undefined') {
    var headerObserver = new ResizeObserver(syncStickyTop);
    headerObserver.observe(header);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
